import styles from './TableEmptyState.module.css';

type Props = {
  title: string;
  description: string;
};

export const TableEmptyState = ({ title, description }: Props) => (
  <div className={styles.container}>
    <div className={styles.title}>{title}</div>
    <div className={styles.description}>{description}</div>
  </div>
);
